/*
 * This file is part of the Sylius package.
 *
 * (c) Paweł Jędrzejewski
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

/* global $, jQuery, document, window, location, getTierpriceContainer */

function handleProductOptionsChange() {
  $('[name*="sylius_add_to_cart[cartItem][variant]"]').on('change', function h() {
    const $productInfo = $(this).parents('.product-info');
    let $selector = '';

    $productInfo.find('#sylius-product-adding-to-cart select').each(function s() {
      const option = $(this).find('option:selected').val();
      $selector += `[data-${$(this).attr('data-option')}="${option}"]`;
    });

    const $price = $productInfo.find('#sylius-variants-pricing').find($selector).attr('data-value');

    if ($price !== undefined) {
      $productInfo.find('#product-price').text($price);
      $productInfo.find('button[type=submit]').removeAttr('disabled');
    } else {
      $productInfo.find('#product-price').text($('#sylius-variants-pricing').attr('data-unavailable-text'));
      $productInfo.find('button[type=submit]').attr('disabled', 'disabled');
    }

    const path = $('#isoshop-variant-links').find($selector).data('value');

    if (path !== undefined) {
      const nextTitle = document.title;
      const nextState = { additionalInformation: 'Updated the URL with JS' };
      window.history.replaceState(nextState, nextTitle, path);
    }
  });
}

function handleProductVariantsChange(quantity = null) {
  $('[name="sylius_add_to_cart[cartItem][variant]"]').on('change', function h(event) {
    const $productInfo = $(this).parents('.product-info');
    // var $price = $(this).parents('tr').find('.sylius-product-variant-price').html();
    let $priceMain = $(this).parents('tr').find('.sylius-product-variant-price').data('price-main');
    let $priceCents = $(this).parents('tr').find('.sylius-product-variant-price').data('price-cents');
    const $details = $(this).parents('tr').find('td').first()
      .find('strong')
      .html();
    const $shipmentTime = $(this).parents('tr').find('.product-shipment-time').html();
    const $originalPrice = $(this).parents('tr').find('.sylius-product-variant-price').siblings('.sylius-product-variant-price-old');
    const originalPriceMain = $originalPrice.data('original-price-main');
    const originalPriceCents = $originalPrice.data('original-price-cents');

    const variantCode = $(event.currentTarget).val();

    if (quantity !== null) {
      const tierpriceContainer = getTierpriceContainer(variantCode, quantity);

      if (tierpriceContainer !== null) {
        $priceMain = tierpriceContainer.data('price-main');
        $priceCents = tierpriceContainer.data('price-cents');
      }
    }

    $productInfo.find('#product-price .price-main').html($priceMain);
    $productInfo.find('#product-price .price-cents').html($priceCents);
    $productInfo.find('.price-details').html(`<span> ${$details}</span>`);
    $productInfo.find('.iso-df-btn-add-to-cart ~ .product-shipment-time').html($shipmentTime !== undefined ? $shipmentTime : '');
    $productInfo.find('.variant-code').html(variantCode);

    const $prodPriceCut = $productInfo.find('#product-price').siblings('.price-cut');
    // $productInfo.find('#product-price').find('br').remove();
    if (originalPriceMain) {
      $prodPriceCut.find('.price-main').html(originalPriceMain);
      $prodPriceCut.find('.price-cents').html(originalPriceCents);
      $prodPriceCut.removeClass('hidden');
    } else {
      $prodPriceCut.find('.price-main').html('');
      $prodPriceCut.find('.price-cents').html('');
      $prodPriceCut.addClass('hidden');
    }

    $productInfo.find('.iso-df-btn-quickview-more').attr('href', $(this).attr('url'));
    const { hash } = window.location;
    const variantValue = $(`#isoshop-variant-links [data-variant-code="${variantCode}"]`).data('value');
    const path = (typeof variantValue === 'string' ? variantValue : '') + hash;

    if (path !== '') {
      const nextTitle = `${document.title} - ${$details}`;
      const nextState = { additionalInformation: 'Updated the URL with JS' };
      window.history.replaceState(nextState, nextTitle, path);
    }

    const $contactMessageBtn = $productInfo.find('.contact-message-btn');

    if ($contactMessageBtn.length) {
      const contactMessageBtnURL = new URL($(location).attr('origin') + $contactMessageBtn.data('url'));
      contactMessageBtnURL.searchParams.set('variant_code', variantCode);
      $contactMessageBtn.attr('data-url', contactMessageBtnURL.pathname + contactMessageBtnURL.search);
    }
  });

  $('.variant-ask').on('click', function v() {
    const $variantAsk = $(this);
    $variantAsk.parents('tr').find('input').trigger('click');
    const navbarHeight = $('#navbar').parents('.navbar').outerHeight();
    const toScroll = $variantAsk.parents('.iso-df-product-add-cart').find('.ask-for-product-btn').offset().top - navbarHeight - 30;
    const $wrapper = $variantAsk.parents('.modal-body').length ? $variantAsk.parents('.modal-body') : $('html');
    setTimeout(() => {
      $wrapper.animate({
        scrollTop: toScroll,
      }, 600);
    }, 600);
  });
}

function setProductShipmentIconTitle() {
  $('[name="sylius_add_to_cart[cartItem][variant]"]').on('change', function v() {
    const $iconElem = $('.icons-style3 #shipment-time');
    const $shipmentTime = $(this).parents('tr').find('.product-shipment-time p').text();
    $iconElem.html($shipmentTime !== '' ? $shipmentTime : '?');
  });
}

(function f($) {
  $.fn.extend({
    variantPrices() {
      if ($('#sylius-variants-pricing').length > 0) {
        handleProductOptionsChange();
      } else if ($('#sylius-product-variants').length > 0) {
        handleProductVariantsChange();
        setProductShipmentIconTitle();
      }
    },
  });
}(jQuery));
